BatchGeoStore.addReducer("MapsManager", function (state, action) {
  state = state || {
    // Loaded just means that new google.maps.Map was called. This does NOT mean
    // it is rendered though. If you need it to be rendered for dimensions and
    // stuff use rendered
    loaded: false,
    // Rendered implies loaded and visible. When it's rendered the map will have
    // width and height and visible to the user.
    rendered: false,
  };

  switch (action.type) {
    case "SET_LOADED":
      return Object.assign({}, state, {
        loaded: action.loaded,
      });

    case "SET_RENDERED":
      return Object.assign({}, state, {
        rendered: action.rendered,
      });

    default:
      return state;
  }
});
